import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  set(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  delete(key: string): void {
    localStorage.removeItem(key);
  }

  get(key: string, json: boolean = true) {
    const response = localStorage.getItem(key)!;
    if (json) {
      return JSON.parse(response);
    }
    return response;
  }

  clearAllData(): void {
    localStorage.clear();
  }
}
